export default "/imgs/investigation-07-mob.png"